import { render, staticRenderFns } from "./ProcessRegistrationPopup.vue?vue&type=template&id=6e8ec101&"
import script from "./ProcessRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./ProcessRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProcessRegistrationPopup.vue?vue&type=style&index=0&id=6e8ec101&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports